var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from 'Theme';
import { store as mainStore } from 'App';
import History, { toParentPath } from 'helpers/History';
import { T as Traduce, t, T } from 'helpers/i18n';
import { Validation } from 'helpers/Validation';
import { mapValues, objectValues } from 'helpers/Utils';
import { Field, FieldType } from 'elements';
import { loading as Loading } from 'elements/Loading';
import { Button as RButton, ButtonGroup, ButtonToolbar, Row, Col } from 'reactstrap';
import theme from 'Theme';
import CalendarAvailable from '../../../components/CalendarAvailable/CalendarAvailable';
import { ButtonsBar, StyledButton } from '../../../Styles';
import { MapSite, SeatZone } from '../../SeatingAreas/Model';
import SeatPickerImp from '../../../components/SeatPickerImp';
import Mapsite from '../../SeatingAreas/container/Mapsite';
import Zoneconfig from '../../SeatingAreas/container/Zoneconfig';
import Stretch from '../Model';
import { Container } from 'reactstrap';
import StretchOtas from './StretchOtas';
import history from 'helpers/History';
import ViewSelectedPrices from './ViewSelectedPrices';
import { DataWeb, Fields } from './DataWeb';
import { MarketingForm } from './MarketingForm';
import PriceCalendarView from '../../../components/PriceCalendar/PriceCalendarView';
import cloneDeep from 'lodash/cloneDeep';
import StretchSetting from './Setting';
var StretchesFormulario = /** @class */ (function (_super) {
    __extends(StretchesFormulario, _super);
    function StretchesFormulario(props) {
        var _this = this;
        var _a, _b, _c, _d, _e;
        _this = _super.call(this, props) || this;
        _this.priceFields = [];
        _this.vueltaPriceFields = [];
        _this.stretchSchema = {};
        _this.state = {
            values: null,
            dataweb: null,
            marketing: null,
            pricesValues: {},
            vueltaPricesValues: [],
            defaultPrice: null,
            collaboratorPricesValues: {},
            collaboratorVueltaPricesValues: {},
            afiliatePricesValues: {},
            afiliateVueltaPricesValues: {},
            priceCalc: 0,
            priceTax: 0,
            taxValue: 0,
            showHora: true,
            showVehicles: true,
            viewSelected: ((_a = _this.props.values) === null || _a === void 0 ? void 0 : _a.id) ? defaultViewSelected : ViewSelected.Field,
            collaboratorSelected: null,
            afiliateSelected: null,
            showPicker: false
        };
        _this.mapNameId = {};
        _this.vueltaMapNameId = {};
        // colaboradores
        _this.collaborators = (_b = _this.props.collaborators) !== null && _b !== void 0 ? _b : [];
        _this.collaboratorsMapeados = _this.collaborators.map(function (item) { return ({
            value: String(item.id),
            name: item.name
        }); });
        _this.collaboratorOptions = __spreadArray([], _this.collaboratorsMapeados, true);
        // afiliados
        _this.afiliates = (_c = _this.props.afiliates) !== null && _c !== void 0 ? _c : [];
        _this.afiliatesMapeados = _this.afiliates.map(function (item) { return ({
            value: String(item.id),
            name: item.name
        }); }).sort(function (a, b) { return a.name.trim().toLowerCase().localeCompare(b.name.trim().toLowerCase()); });
        _this.afiliateOptions = __spreadArray([], _this.afiliatesMapeados, true);
        /*componentWillMount(): void {
          this.setState({
              values: this.parsedValues(),
              pricesValues: this.parsedPricesValues(this.props)
            },
            () => {
              // console.log('state changed in componentWillMount')
            })
        }
      */
        _this.handleChange = function (name, value, column) {
            var _a, _b, _c, _d;
            console.log('handleChange: ', "name: ".concat(name, " value: ").concat(typeof value === 'object' ? JSON.stringify(value) : value, " column: ").concat(column));
            // console.log('name', name)
            // console.log('column', column)
            // console.log('value', value)
            // Schedules
            // console.log('value', value)
            // console.log('typeof: ', typeof value)
            var multiple = typeof value === 'object';
            var schedulesValueIda = [];
            var schedulesValueVuelta = [];
            if (typeof value === 'object' && Array.isArray(value)) {
                if (name === 'horasIda') {
                    value.forEach(function (item) {
                        var hora = _this.props.schedules.filter(function (schedule) { return schedule.id === Number(item); });
                        if (hora.length > 0) {
                            schedulesValueIda.push(hora[0]);
                        }
                    });
                }
                else if (name === 'horasVuelta') {
                    value.forEach(function (item) {
                        var hora = _this.props.schedules.filter(function (schedule) { return schedule.id === Number(item); });
                        if (hora.length > 0)
                            schedulesValueVuelta.push(hora[0]);
                    });
                }
            }
            if (name === 'tramoHora') {
                // console.log('handleChange - tramoHora', value)
                if (!_this.state.values.horasIda ||
                    _this.state.values.horasIda.length === 0) {
                    return _this.props.stores.UI.newWarning('no se puede seleccionar tramo hora si no hay configurados horarios de salida');
                }
                _this.setState(function (prev) {
                    var _a;
                    return ({
                        showHora: value,
                        values: __assign(__assign({}, prev.values), (_a = {}, _a[column ? column : name] = value, _a.hoponHopoff = value ? false : prev.values.hoponHopoff, _a.showHora = value, _a))
                    });
                });
            }
            else if (name === 'hoponHopoff') {
                _this.setState(function (prev) {
                    var _a;
                    return ({
                        showHora: !value,
                        values: __assign(__assign({}, prev.values), (_a = {}, _a[column ? column : name] = value, _a.tramoHora = value ? false : prev.values.tramoHora, _a.vuelta = value ? false : prev.values.vuelta, _a))
                    });
                });
            }
            else if (name === 'vuelta') {
                _this.setState(function (prev) {
                    var _a;
                    return ({
                        values: __assign(__assign({}, prev.values), (_a = {}, _a[column ? column : name] = value, _a.hoponHopoff = value ? false : prev.values.hoponHopoff, _a))
                    });
                });
            }
            else if (name === 'tax') {
                var taxSelected = _this.props.taxes[Number(value) - 1];
                var priceCalc = taxSelected
                    ? _this.state.priceTax / (taxSelected.value + 1)
                    : 0;
                _this.setState({
                    values: __assign(__assign({}, _this.state.values), (_a = {}, _a[column ? column : name] = value, _a)),
                    priceCalc: priceCalc
                });
            }
            else if (name === 'horasIda') {
                // console.log('multiple: ', multiple)
                // console.log('schedulesValueIda: ', schedulesValueIda)
                // console.log('name: ', name)
                // console.log('value: ', value)
                _this.setState({
                    values: __assign(__assign({}, _this.state.values), (_b = {}, _b[column ? column : name] = multiple ? schedulesValueIda : value, _b))
                }, function () {
                    // console.log('else - handleChange: state.horasIda', this.state.values)
                });
            }
            else if (name === 'horasVuelta') {
                // console.log('multiple: ', multiple)
                // console.log('schedulesValueVuelta: ', schedulesValueVuelta)
                // console.log('name: ', name)
                // console.log('value: ', value)
                _this.setState({
                    values: __assign(__assign({}, _this.state.values), (_c = {}, _c[column ? column : name] = multiple ? schedulesValueVuelta : value, _c))
                });
            }
            else if (name === 'withVehicle') {
                _this.setState(function (prev) {
                    var _a;
                    return ({
                        showVehicles: value,
                        values: __assign(__assign({}, prev.values), (_a = {}, _a[column ? column : name] = value, _a.hoponHopoff = value ? false : prev.values.hoponHopoff, _a.showVehicles = value, _a))
                    });
                });
            }
            else {
                console.log("poniendo column: ".concat(column, "} o name: ").concat(name, " con valor: ").concat(value));
                _this.setState({
                    values: __assign(__assign({}, _this.state.values), (_d = {}, _d[column ? column : name] = value, _d))
                });
            }
        };
        _this.handleChangePrices = function (name, value) {
            var _a;
            console.log('handleChangePrices: ', "name: ".concat(name, " value: "), value);
            var priceField = _this.priceFields.find(function (pf) { return pf.name === name; });
            if (priceField) {
                priceField.value = value;
            }
            _this.setState({ pricesValues: __assign(__assign({}, _this.state.pricesValues), (_a = {}, _a[name] = value, _a)) }, function () {
                // console.log('handleChangePrices: state.values', this.state.values)
            });
        };
        _this.handleDefaultPrice = function (field) {
            console.log('handleDefaultPrice - field: ', field);
            console.log('pricesValues: ', _this.state.pricesValues);
            _this.setState({ defaultPrice: Number(field.id) });
        };
        _this.handleChangeVueltaPrices = function (name, value) {
            var _a;
            // console.log('handleChange: ', `name: ${name} value: ${value}`)
            _this.setState({ vueltaPricesValues: __assign(__assign({}, _this.state.vueltaPricesValues), (_a = {}, _a[name] = value, _a)) }, function () {
                // console.log('handleChangePrices: state.vueltaPricesValues', this.state.vueltaPricesValues)
            });
        };
        _this.handleChangeCollaboratorPrices = function (name, value, vuelta) {
            // console.log('handleChange: ', `name: ${name} value: ${value}`)
            var id = _this.state.collaboratorSelected.id;
            if (!vuelta) {
                var oldCollaboratorPricesValues = cloneDeep(_this.state.collaboratorPricesValues);
                if (oldCollaboratorPricesValues[id]) {
                    oldCollaboratorPricesValues[id][name] = value;
                }
                else {
                    var temp = {};
                    temp[name] = value;
                    oldCollaboratorPricesValues[id] = temp;
                }
                _this.setState({ collaboratorPricesValues: oldCollaboratorPricesValues }, function () {
                    // console.log('handleChangeCollaboratorPrices: state.collaboratorPricesValues', this.state.collaboratorPricesValues)
                });
            }
            else {
                var oldCollaboratorVueltaPricesValues = _this.state
                    .collaboratorVueltaPricesValues;
                if (oldCollaboratorVueltaPricesValues[id]) {
                    oldCollaboratorVueltaPricesValues[id][name] =
                        value === '' ? undefined : value;
                }
                else {
                    var temp = {};
                    temp[name] = value === '' ? undefined : value;
                    oldCollaboratorVueltaPricesValues[id] = temp;
                }
                _this.setState({ collaboratorVueltaPricesValues: oldCollaboratorVueltaPricesValues }, function () {
                    // console.log('handleChangeCollaboratorPrices: state.collaboratorPricesValues', this.state.collaboratorPricesValues)
                });
            }
        };
        _this.handleChangeAfiliatePrices = function (name, value, vuelta) {
            var id = _this.state.afiliateSelected.id;
            if (!vuelta) {
                var oldAfiliatePricesValues = cloneDeep(_this.state.afiliatePricesValues);
                if (oldAfiliatePricesValues[id]) {
                    oldAfiliatePricesValues[id][name] = value === '' ? undefined : value;
                }
                else {
                    var temp = {};
                    temp[name] = value === '' ? undefined : value;
                    oldAfiliatePricesValues[id] = temp;
                }
                _this.setState({ afiliatePricesValues: oldAfiliatePricesValues }, function () {
                });
            }
            else {
                var oldAfiliateVueltaPricesValues = cloneDeep(_this.state.afiliateVueltaPricesValues);
                if (oldAfiliateVueltaPricesValues[id]) {
                    oldAfiliateVueltaPricesValues[id][name] =
                        value === '' ? undefined : value;
                }
                else {
                    var temp = {};
                    temp[name] = value === '' ? undefined : value;
                    oldAfiliateVueltaPricesValues[id] = temp;
                }
                _this.setState({ afiliateVueltaPricesValues: oldAfiliateVueltaPricesValues }, function () {
                    // console.log('handleChangeCollaboratorPrices: state.collaboratorPricesValues', this.state.collaboratorPricesValues)
                });
            }
        };
        _this.handleChangeSelectCollaborator = function (e) {
            // console.log('Number(e.target.value): ', Number(e.target.value))
            var collaboratorSelected = _this.props.collaborators.find(function (value) { return value.id === Number(e.target.value); });
            if (!collaboratorSelected) {
                _this.setState({ collaboratorSelected: null });
                return;
            }
            var id = collaboratorSelected.id;
            var oldCollaboratorPricesValues = _this.state.collaboratorPricesValues;
            var oldCollaboratorVueltaPricesValues = _this.state.collaboratorVueltaPricesValues;
            oldCollaboratorPricesValues[id] = _this.parsedCollaboratorPricesValues(collaboratorSelected, false);
            oldCollaboratorVueltaPricesValues[id] = _this.parsedCollaboratorPricesValues(collaboratorSelected, true);
            _this.setState({
                collaboratorSelected: collaboratorSelected,
                collaboratorPricesValues: oldCollaboratorPricesValues,
                collaboratorVueltaPricesValues: oldCollaboratorVueltaPricesValues
            });
        };
        _this.handleChangeSelectAfiliate = function (e) {
            // console.log('Number(e.target.value): ', Number(e.target.value))
            var afiliateSelected = _this.props.afiliates.find(function (value) { return value.id === Number(e.target.value); });
            if (!afiliateSelected) {
                _this.setState({ afiliateSelected: null });
                return;
            }
            var id = afiliateSelected.id;
            var oldAfiliatePricesValues = _this.state.afiliatePricesValues;
            var oldAfiliateVueltaPricesValues = _this.state.afiliateVueltaPricesValues;
            oldAfiliatePricesValues[id] = _this.parsedAfiliatePricesValues(afiliateSelected, false);
            oldAfiliateVueltaPricesValues[id] = _this.parsedAfiliatePricesValues(afiliateSelected, true);
            _this.setState({
                afiliateSelected: afiliateSelected,
                afiliatePricesValues: oldAfiliatePricesValues,
                afiliateVueltaPricesValues: oldAfiliateVueltaPricesValues
            });
        };
        _this.handleCollaboratorSave = function (vuelta) {
            var collaborator = _this.state.collaboratorSelected;
            var values = !vuelta
                ? _this.state.collaboratorPricesValues[collaborator.id]
                : _this.state.collaboratorVueltaPricesValues[collaborator.id];
            // tengo que cambiar los nombres de las categorías por el id
            var toSave = [];
            var _loop_1 = function (name, price) {
                var result = {};
                if (price === undefined) {
                    return "continue";
                }
                var passengerCategory = _this.props.passengerCategories.find(function (passenger) { return passenger.name === name; });
                result['stretch_id'] = _this.props.values.id;
                result['client_id'] = collaborator.client_id;
                result['collaborator_id'] = collaborator.id;
                result['passengerCategory_id'] = passengerCategory.id;
                result['priceNet'] = price;
                result['idaVuelta'] = vuelta;
                toSave.push(result);
            };
            for (var _i = 0, _a = Object.entries(values); _i < _a.length; _i++) {
                var _b = _a[_i], name = _b[0], price = _b[1];
                _loop_1(name, price);
            }
            _this.props.stores.stretches.saveCollaboratorPrices(toSave).then(function (value) {
                _this.props.stores.UI.newWarning('precio guardado correctamente');
            });
        };
        _this.handleAfiliateSave = function (vuelta) {
            var afiliate = _this.state.afiliateSelected;
            var values = !vuelta
                ? _this.state.afiliatePricesValues[afiliate.id]
                : _this.state.afiliateVueltaPricesValues[afiliate.id];
            // tengo que cambiar los nombres de las categorías por el id
            var toSave = [];
            var _loop_2 = function (name, price) {
                var result = {};
                if (price === undefined) {
                    return "continue";
                }
                var passengerCategory = _this.props.passengerCategories.find(function (passenger) { return passenger.name === name; });
                result['stretch_id'] = _this.props.values.id;
                // result['client_id'] = afiliate.client_id
                result['afiliate_id'] = afiliate.id;
                result['passengerCategory_id'] = passengerCategory.id;
                result['priceNet'] = price;
                result['idaVuelta'] = vuelta;
                toSave.push(result);
            };
            for (var _i = 0, _a = Object.entries(values); _i < _a.length; _i++) {
                var _b = _a[_i], name = _b[0], price = _b[1];
                _loop_2(name, price);
            }
            _this.props.stores.stretches.saveAfiliatePrices(toSave).then(function (value) {
                _this.props.stores.UI.newWarning('precio guardado correctamente');
            });
        };
        _this.handleCancel = function () {
            // console.log('handleCancel')
            var onCancel = _this.props.onCancel;
            if (onCancel)
                return onCancel();
            toParentPath();
        };
        _this.handleDisable = function (disable) { return function () {
            // console.log('handleDisable')
            var _a = _this.props, values = _a.values, store = _a.store, onDisable = _a.onDisable;
            var accept = confirm(t(disable ? 'confirmDisable' : 'confirmEnable'));
            if (accept) {
                if (onDisable)
                    return onDisable(disable);
                if (store && store.disable && values) {
                    store.disable(values.id, disable).then(toParentPath);
                }
            }
        }; };
        _this.handleDelete = function () {
            /*console.log('handleDelete')
            const {values, store, onDelete} = this.props
        
            const accept = confirm(t('confirmDelete'))
            if (accept) {
              if (onDelete) return onDelete()
              if (store && store.delete && values) {
                store.delete(values.id).then(toParentPath)
              }
            }*/
        };
        _this.handleReset = function () {
            // console.log('handleReset')
            _this.setState({
                values: _this.parsedValues(),
                pricesValues: _this.parsedPricesValues(),
                vueltaPricesValues: _this.parsedVueltaPricesValues(_this.props)
            });
        };
        _this.changeToId = function (stretchPrices, pricesValues) {
            // console.log('changeToId')
            var result = {};
            // let {pricesValues} = this.state.pricesValues
            for (var item in stretchPrices) {
                if (stretchPrices.hasOwnProperty(item)) {
                    // console.log('changeToId - item', item)
                    result[_this.mapNameId[item]] = pricesValues[item];
                }
            }
            // return stretchPrices
            return result;
        };
        _this.changeVueltaToId = function (stretchPrices) {
            // console.log('changeToId')
            var result = {};
            var vueltaPricesValues = _this.state.vueltaPricesValues;
            for (var item in vueltaPricesValues) {
                if (vueltaPricesValues.hasOwnProperty(item)) {
                    // console.log('changeToId - item', item)
                    result[_this.vueltaMapNameId[item]] = vueltaPricesValues[item];
                }
            }
            // return stretchPrices
            return result;
        };
        _this.handleSubmit = function () {
            // console.log('handleSubmit - priceFields_', this.props.priceFields)
            var _a = _this.props, propsValues = _a.values, store = _a.store, duplicate = _a.duplicate, onSubmit = _a.onSubmit;
            var values = __assign({}, _this.state.values);
            values.disabledDays = _this.disabledDays;
            values.mapSite = _this.mapSite;
            delete values.showHora;
            delete values.showVehicles;
            var validation = new Validation(values, _this.schema);
            if (validation.valid) {
                // compruebo que origin y destination tiene valor si vuelta es true
                if (values.vuelta) {
                    if (!values.origin) {
                        return mainStore.UI.newWarning("".concat(t('origin'), " no puede estar vac\u00EDo"));
                    }
                    if (!values.destination) {
                        return mainStore.UI.newWarning("".concat(t('destination'), " no puede estar vac\u00EDo"));
                    }
                }
                // si es tramoHora tiene que tener hora seleccionada
                if (values.tramoHora && values.horasIda && values.horasIda.length === 0) {
                    return mainStore.UI.newWarning('no ha seleccionado hora de salida para tramo hora');
                }
                if (values.tramoHora && !values.horasIda) {
                    return mainStore.UI.newWarning('no ha configurado horas de salida, no puede ser tramo hora');
                }
                if (!duplicate) {
                    // Remove unmodified value
                    _this.fields.map(function (field) {
                        if (propsValues &&
                            values[field.column ? field.column : field.name] ===
                                propsValues[field.column ? field.column : field.name]) {
                            delete values[field.column ? field.column : field.name];
                        }
                    });
                }
                else {
                    // estamos duplicando
                    // compruebo datos unicos que se hayan cambiado:
                    // name, code, ¿¿stretchOtas??
                    if (propsValues['name'] === values['name']) {
                        return _this.props.stores.UI.newWarning("".concat(t('name'), " tiene que ser unico"));
                    }
                    if (propsValues['code'] === values['code']) {
                        return _this.props.stores.UI.newWarning("".concat(t('code'), " tiene que ser unico"));
                    }
                }
                if (Object.keys(values).length === 0 // &&
                // Object.keys(pricesValues).length === 0 &&
                // Object.keys(vueltaPricesValues).length === 0
                )
                    return mainStore.UI.newWarning(T('nothingModified'));
                // Convert empty strings to null
                values = mapValues(values, function (value) { return (value === '' ? null : value); });
                // add extras como Extra[] ya que tengo ids de extras almacenados
                if (values.extras && values.extras.length > 0) {
                    var extras_1 = [];
                    values.extras = values.extras.forEach(function (extra) {
                        var temp = _this.props.extras.find(function (value) { return value.id === Number(extra); });
                        if (temp) {
                            extras_1.push(temp);
                        }
                    });
                    values.extras = extras_1;
                }
                // Use FormData instead of JSON if there is a image in value
                var data_1;
                // console.log('Object.keys(this.schema).includes(\'image\'', Object.keys(this.schema).includes('image'))
                // console.log('values: ', values)
                if (Object.keys(_this.schema).includes('image') && values['image']) {
                    // console.log('handleSubmit - image')
                    data_1 = new FormData();
                    Object.keys(values).forEach(function (key) {
                        if (key === 'image' &&
                            (values[key] !== undefined || values[key] !== null)) {
                            // añado image porque tiene que ir como propiedad, el resto va en values y/o stretchValues
                            if (values[key] instanceof FileList) {
                                for (var i = 0; i < values[key].length; i++) {
                                    data_1.append(key, values[key][i]);
                                }
                            }
                            else {
                                data_1.append(key, values[key]);
                            }
                        }
                    });
                    data_1.append('values', JSON.stringify(values));
                }
                else {
                    data_1 = {};
                    data_1.values = values;
                }
                delete values.showHora;
                delete values.showVehicles;
                // console.log('handleSubmit - data', data)
                // console.log('handleSubmit - data', data)
                if (onSubmit)
                    return onSubmit(data_1);
                // console.log('!onSubmit')
                if (store && data_1) {
                    var request = void 0;
                    if (propsValues && !duplicate) {
                        request = store.update(propsValues.id, data_1);
                    }
                    else {
                        delete data_1.id;
                        request = store.create(data_1);
                    }
                    request.then(function (result) {
                        var _a, _b;
                        if (!result)
                            return;
                        // envío a civitrip si corresponde
                        try {
                            var clientName = (_b = (_a = _this.props.stores.users) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.client;
                            if (!clientName) {
                                return _this.props.stores.UI.newError(T('errorCivitrip') + ' ' + T('client'));
                            }
                            _this.props.stores.civitripClientsStore.read(clientName).then(function (value) {
                                _this.props.stores.civitripClientsStore.sendStretchesToCivitrip([result]).then(function (response) {
                                    console.log('response civitrip: ', response);
                                    return _this.props.stores.UI.newWarning(T('saved') + ' - ' + T('successCivitrip'));
                                }).catch(function (error) {
                                    console.log('error enviando civitrip: ', error);
                                });
                            })
                                .catch(function (error) {
                                console.log('error read civitrip: ', error);
                            });
                        }
                        catch (e) {
                            return _this.props.stores.UI.newError(T('errorCivitrip'));
                        }
                        if (_this.state.viewSelected === ViewSelected.Field) {
                            return history.push('/stretches/' + propsValues.id);
                        }
                        if (!duplicate) {
                            return _this.props.stores.UI.newWarning(T('saved'));
                            // return toParentPath()
                        }
                        return history.replace(history.location.pathname
                            .split('/')
                            .slice(0, -2)
                            .join('/'));
                    });
                }
                else {
                    mainStore.UI.newWarning('error indefinido');
                }
            }
            else {
                // error en la validacion
                // console.log('FormStretch -handleSubmit - !validation.valid', validation)
                // console.log('handleSubmit - !stretchValidation.valid', stretchValidation)
                if (!validation.valid)
                    mainStore.UI.newWarning(objectValues(validation.errors).join('\n'));
                /*if (!stretchValidation.valid)
                  mainStore.UI.newWarning(
                    objectValues(stretchValidation.errors).join('\n')
                  )*/
            }
        };
        _this.handleOnDateClick = function (disabledDays) {
            _this.disabledDays = disabledDays;
        };
        _this.fields = props.fields.filter(function (field) { return field; });
        // console.log('StretchesFormulario - constructor - this.fields: ', this.fields)
        _this.schema = _this.fields.reduce(function (previous, _a) {
            var name = _a.name, rules = _a.rules, column = _a.column;
            previous[column ? column : name] = rules;
            return previous;
        }, {});
        if (props.priceFields) {
            // hay passengerCategories en el sistema
            _this.priceFields = cloneDeep(props.priceFields); // props.priceFields.filter(field => field)
            _this.stretchSchema = _this.priceFields.reduce(function (previous, _a) {
                var name = _a.name, rules = _a.rules;
                previous[name] = rules;
                return previous;
            }, {});
            _this.priceFields.forEach(function (priceField) {
                _this.mapNameId[priceField.name] = priceField.id;
            });
        }
        if (props.vueltaPriceFields) {
            // hay passengerCategories en el sistema
            _this.vueltaPriceFields = props.vueltaPriceFields.filter(function (field) { return field; });
            _this.vueltaStretchSchema = _this.vueltaPriceFields.reduce(function (previous, _a) {
                var name = _a.name, rules = _a.rules;
                previous[name] = rules;
                return previous;
            }, {});
            _this.vueltaPriceFields.forEach(function (priceField) {
                _this.vueltaMapNameId[priceField.name] = priceField.id;
            });
        }
        _this.state.values = _this.parsedValues(_this.props);
        if (props.values) {
            console.log('StretechesFormulario - constructor - props.values: ', props.values);
            _this.disabledDays = props.values.disabledDays || [];
            _this.mapSite = new MapSite();
            if (props.values.mapSite && props.values.mapSite.seatZones) {
                _this.mapSite.seatZones = props.values.mapSite.seatZones.map(function (seatZone) { return new SeatZone(seatZone); });
            }
            else {
                _this.mapSite.seatZones = [];
            }
            if (!props.duplicate) {
                _this.state.values.stretchOtas = props.values.stretchOtas || [];
            }
        }
        else {
            _this.disabledDays = [];
        }
        if (_this.state.values.tramoHora &&
            (!_this.state.values.horasIda || _this.state.values.horasIda.length === 0)) {
            _this.state.values.tramoHora = false;
        }
        _this.state.pricesValues = _this.parsedPricesValues();
        _this.state.vueltaPricesValues = _this.parsedVueltaPricesValues(_this.props);
        _this.state.dataweb = (_d = _this.props.values) === null || _d === void 0 ? void 0 : _d.dataweb;
        _this.state.marketing = (_e = _this.props.values) === null || _e === void 0 ? void 0 : _e.marketing;
        return _this;
    }
    StretchesFormulario.prototype.render = function () {
        var _this = this;
        var _a;
        // console.log('FormStretch - render()')
        var _b = this.props, reactstrap = _b.reactstrap, canBeDeleted = _b.delete, loading = _b.loading, destinations = _b.destinations, categories = _b.categories, tags = _b.tags;
        // console.log('values: ', this.props.values)
        var _c = this.state, values = _c.values, pricesValues = _c.pricesValues, showHora = _c.showHora, showVehicles = _c.showVehicles, viewSelected = _c.viewSelected, vueltaPricesValues = _c.vueltaPricesValues, collaboratorSelected = _c.collaboratorSelected, afiliateSelected = _c.afiliateSelected, collaboratorPricesValues = _c.collaboratorPricesValues, afiliatePricesValues = _c.afiliatePricesValues, collaboratorVueltaPricesValues = _c.collaboratorVueltaPricesValues, afiliateVueltaPricesValues = _c.afiliateVueltaPricesValues;
        // console.log('FormStretch - render - collaboratorPricesValues', collaboratorPricesValues)
        // console.log('FormStretch - render - \'disabled\' in (this.props.values || {})', 'disabled' in (this.props.values || {}))
        var canBeDisabled = 'disabled_at' in (this.props.values || {});
        var disabled = canBeDisabled && this.props.values.disabled_at != null;
        var hasParent = (History.location.pathname.match(/\//g) || []).length >= 2;
        var taxValue = this.props.stores.taxes.findById(values.tax_id);
        console.log('values: ', this.state.values);
        return (React.createElement(Wrapper, null,
            React.createElement(Container, null,
                values &&
                    React.createElement("div", { style: {
                            color: 'green'
                        } }, values.name),
                React.createElement(Row, null,
                    React.createElement(Col, null,
                        React.createElement(ButtonToolbar, { style: { backgroundColor: 'white', marginTop: '10px' } },
                            React.createElement(ButtonGroup, null,
                                React.createElement(RButton, { outline: true, style: {
                                        color: this.state.viewSelected === ViewSelected.Field
                                            ? theme.color.primary
                                            : theme.color.secondary
                                    }, onClick: function () {
                                        return _this.setState({ viewSelected: ViewSelected.Field });
                                    } }, Traduce('settings')),
                                this.props.values && this.props.values.id && React.createElement(RButton, { outline: true, style: {
                                        color: this.state.viewSelected ===
                                            ViewSelected.CalendarAvailable
                                            ? theme.color.primary
                                            : theme.color.secondary
                                    }, onClick: function () {
                                        return _this.setState({
                                            viewSelected: ViewSelected.CalendarAvailable
                                        });
                                    } }, Traduce('calendarAvailable')),
                                this.props.values && this.props.values.id && React.createElement(RButton, { outline: true, style: {
                                        color: this.state.viewSelected ===
                                            ViewSelected.CalendarPrices
                                            ? theme.color.primary
                                            : theme.color.secondary
                                    }, onClick: function () {
                                        return _this.setState({
                                            viewSelected: ViewSelected.CalendarPrices
                                        });
                                    } }, Traduce('calendarPrices')),
                                this.props.values && this.props.values.id && React.createElement(RButton, { outline: true, style: {
                                        color: this.state.viewSelected === ViewSelected.Prices
                                            ? theme.color.primary
                                            : theme.color.secondary
                                    }, onClick: function () {
                                        return _this.setState({ viewSelected: ViewSelected.Prices });
                                    } }, Traduce('prices')),
                                this.props.values && this.props.values.id && React.createElement(RButton, { outline: true, style: {
                                        color: this.state.viewSelected === ViewSelected.DataWeb
                                            ? theme.color.primary
                                            : theme.color.secondary
                                    }, onClick: function () {
                                        return _this.setState({ viewSelected: ViewSelected.DataWeb });
                                    } }, Traduce('dataWeb')),
                                this.props.values && this.props.values.id && React.createElement(RButton, { outline: true, style: {
                                        color: this.state.viewSelected === ViewSelected.Marketing
                                            ? theme.color.primary
                                            : theme.color.secondary
                                    }, onClick: function () {
                                        return _this.setState({ viewSelected: ViewSelected.Marketing });
                                    } }, Traduce('marketing'))))))),
            React.createElement(Container, null, viewSelected === ViewSelected.Field &&
                React.createElement(StretchSetting, { values: this.state.values, options: {
                        taxesOptions: this.props.fields.find(function (item) { return item.name === 'tax'; }).options,
                        operationLinesOptions: this.props.fields.find(function (item) { return item.name === 'operationline'; }).options,
                        receiptLayoutsOptions: this.props.fields.find(function (item) { return item.name === 'receiptLayout'; }).options,
                        headboardsOptions: this.props.fields.find(function (item) { return item.name === 'cabeceraTicket'; }).options,
                        horasIdaOptions: this.props.fields.find(function (item) { return item.name === 'horasIda'; }).options,
                    }, onChange: this.handleChange })),
            React.createElement(Container, null,
                React.createElement(Wrapper, { style: { marginBottom: '80px' } }, viewSelected === ViewSelected.Field &&
                    reactstrap ?
                    React.createElement(Container, null, groupFieldsByPattern(markConditionalFields(this.fields, values, showHora, showVehicles), getPattern()).map(function (row, index) {
                        var colSize = Math.floor(12 / row.length) || 12; // si row.length = 0, fallback a 12
                        var justifyClass = row.length < 4 ? 'justify-content-center' : '';
                        return (React.createElement(Row, { key: "row_".concat(index), className: "align-items-center align-items-center ".concat(justifyClass) }, row.map(function (field) {
                            return (React.createElement(Col, { key: "col_".concat(field.name), xl: colSize, md: colSize, sm: 12 },
                                React.createElement(Field, { reactstrap: reactstrap, key: field.name, field: __assign(__assign({ disabled: field.disabled }, field), { value: values[field.column ? field.column : field.name] ||
                                            (values[field.column ? field.column : field.name] === 0
                                                ? '0'
                                                : '') }), onChange: _this.handleChange })));
                        })));
                    }))
                    : viewSelected === ViewSelected.Field &&
                        this.fields.map(function (field) {
                            // console.log('field.name', field.name)
                            // console.log('showHora', showHora)
                            if ((field.name === 'horasIda' || field.name === 'horasVuelta') &&
                                !showHora) {
                                return null;
                            }
                            if (field.name === 'vehicles' && !showVehicles) {
                                return null;
                            }
                            if (field.name === 'dateMaxToReserve') {
                                if (values['typeMaxToReserve'] !== 'byDate') {
                                    return null;
                                }
                            }
                            if (field.name === 'valueMaxToReserve') {
                                if (values['typeMaxToReserve'] === 'byDate') {
                                    return null;
                                }
                            }
                            if (field.name === 'dateMaxBeforeReserve') {
                                if (values['typeMaxToReserve'] !== 'byDate') {
                                    return null;
                                }
                            }
                            if (field.name === 'valueMaxBeforeReserve') {
                                if (values['typeMaxBeforeReserve'] === 'byDate') {
                                    return null;
                                }
                            }
                            /*if (field.name === 'extras') {
                              return null
                            }*/
                            return (React.createElement(Field, { key: field.name, field: __assign(__assign({}, field), { value: values[field.column ? field.column : field.name] ||
                                        (values[field.column ? field.column : field.name] === 0
                                            ? '0'
                                            : '') }), onChange: _this.handleChange }));
                        }))),
            viewSelected === ViewSelected.Ota && (React.createElement(StretchOtas, { stretch: values, stretchOtas: values.stretchOtas || [], onChange: function (stretchOtas) {
                    // console.log('stretchOtas: ', stretchOtas)
                } })),
            viewSelected === ViewSelected.Seatmap && React.createElement(SeatPickerImp, null),
            viewSelected === ViewSelected.Mapsite && (React.createElement(Mapsite, { mapSite: this.mapSite ? this.mapSite.seatZones : [], onResized: function (mapSite) {
                    // console.log('position: ', position)
                    _this.mapSite.seatZones = mapSite;
                }, onDragged: function (mapSite) {
                    // console.log('data: ', mapSite)
                    _this.mapSite.seatZones = mapSite;
                } })),
            viewSelected === ViewSelected.Areaconfig && (React.createElement(Zoneconfig, { mapSite: this.mapSite ? this.mapSite.seatZones : [], onChange: function (mapSite) {
                    console.log('StretechesFormulario - onChange - mapSite: ', mapSite);
                    _this.mapSite = mapSite;
                } })),
            viewSelected === ViewSelected.CalendarAvailable && (React.createElement(CalendarAvailable, { disabledDays: this.disabledDays, onDateClick: this.handleOnDateClick, stretch: new Stretch(this.props.values) })),
            viewSelected === ViewSelected.Prices && (React.createElement(Container, null,
                React.createElement(ViewSelectedPrices, { values: values, taxValue: taxValue, money: this.props.stores.moneysStore.getPrimaryMoney().alphabeticCode, pricesValues: pricesValues, priceFields: this.priceFields, vuelta: this.state.values.vuelta, vueltaPriceFields: this.vueltaPriceFields, vueltaPricesValues: vueltaPricesValues, collaboratorSelected: collaboratorSelected, afiliateSelected: afiliateSelected, collaboratorPriceFields: this.props.collaboratorPriceFields, afiliatePriceFields: this.props.afiliatePriceFields, collaboratorVueltaPriceFields: this.props.collaboratorVueltaPriceFields, afiliateVueltaPriceFields: this.props.collaboratorVueltaPriceFields, collaboratorPricesValues: collaboratorPricesValues, afiliatePricesValues: afiliatePricesValues, collaboratorVueltaPricesValues: collaboratorVueltaPricesValues, afiliateVueltaPricesValues: afiliateVueltaPricesValues, collaboratorOptions: this.collaboratorOptions, afiliateOptions: this.afiliateOptions, onChangeVueltaPrices: this.handleChangeVueltaPrices, onChangePrices: this.handleChangePrices, onSavePrice: function (tiers, passengerCategory_id) {
                        // setLoading(true)
                        var stretch_id = _this.props.values.id;
                        var money_id = _this.props.values.money_id;
                        var typePrice = 'primary';
                        var idaVuelta = false;
                        _this.props.stores.pricesStore.save(tiers, stretch_id, passengerCategory_id, typePrice, money_id, idaVuelta).then(function (value) {
                            _this.props.stores.UI.newWarning(T('saved'));
                        }).catch(function (error) {
                        });
                    }, 
                    // onDefaultPrice={this.handleDefaultPrice}
                    onChangeSelectCollaborator: this.handleChangeSelectCollaborator, onChangeSelectAfiliate: this.handleChangeSelectAfiliate, onCollaboratorSave: this.handleCollaboratorSave, onAfiliateSave: this.handleAfiliateSave, onChangeCollaboratorPrices: this.handleChangeCollaboratorPrices, onChangeAfiliatePrices: this.handleChangeAfiliatePrices }))),
            viewSelected === ViewSelected.CalendarPrices && (React.createElement(PriceCalendarView, { stretch: new Stretch(this.props.values), money: this.props.stores.moneysStore.getPrimaryMoney() })),
            viewSelected === ViewSelected.Marketing &&
                React.createElement(MarketingForm
                // @ts-ignore
                , { 
                    // @ts-ignore
                    values: this.state.marketing, 
                    // stretch={this.props.values}
                    onChange: function (name, value, column) {
                    }, onSubmit: function (data) {
                        var _a;
                        if ((_a = _this.props.values) === null || _a === void 0 ? void 0 : _a.id) {
                            // console.log('onSubmit - data: ', data)
                            if (data instanceof FormData) {
                                data.append('stretch_id', _this.props.values.id);
                            }
                            else {
                                data.stretch_id = _this.props.values.id;
                            }
                            if (_this.props.values.marketing) {
                                _this.props.stores.marketingStore.update(_this.props.values.marketing.id, data).then(function (value) {
                                    _this.setState({ marketing: value });
                                });
                            }
                            else {
                                _this.props.stores.marketingStore.create(data).then(function (value) {
                                    _this.setState({ marketing: value });
                                });
                            }
                        }
                    }, onDefault: function () {
                        _this.props.stores.marketingStore.createDefault({ data: { owner_ids: values.id } })
                            .then(function (result) {
                            _this.state.values['marketing'] = result;
                        })
                            .catch(function (error) {
                        });
                    } }),
            viewSelected === ViewSelected.DataWeb &&
                React.createElement(Container, null,
                    React.createElement(DataWeb, { dataweb: this.state.dataweb, destinations: destinations, categories: categories, tags: tags, stretch_id: (_a = this.props.values) === null || _a === void 0 ? void 0 : _a.id, onChange: function (_a) {
                            var value = _a.value, field = _a.field, lang = _a.lang;
                            var temp = cloneDeep(_this.state.dataweb) || {};
                            // console.log('field: ', field)
                            if (field === 'locationsPoints') {
                                temp[field] = value;
                                // console.log('temp: ', temp)
                                _this.setState({ dataweb: temp });
                                return _this.handleChange('dataweb', temp, null);
                            }
                            if (field === 'destination' || field === 'category' || field === 'tag') {
                                var valueToModify = void 0;
                                var predicade = function (item) { return item.id === value; };
                                switch (field) {
                                    case 'destination':
                                        valueToModify = destinations === null || destinations === void 0 ? void 0 : destinations.find(predicade);
                                        break;
                                    case 'category':
                                        valueToModify = [];
                                        var _loop_3 = function (id) {
                                            var cat = categories.find(function (item) { return item.id === id; });
                                            valueToModify.push(cat);
                                        };
                                        for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                                            var id = value_1[_i];
                                            _loop_3(id);
                                        }
                                        break;
                                    case 'tag':
                                        valueToModify = [];
                                        var _loop_4 = function (tagId) {
                                            var tag = tags.find(function (item) { return item.id === tagId; });
                                            valueToModify.push(tag);
                                        };
                                        for (var _b = 0, value_2 = value; _b < value_2.length; _b++) {
                                            var tagId = value_2[_b];
                                            _loop_4(tagId);
                                        }
                                        break;
                                    default:
                                }
                                temp[field] = valueToModify;
                                _this.setState({ dataweb: temp });
                                _this.handleChange('dataweb', temp, null);
                                return;
                            }
                            // href, description, terminos y condiciones
                            if (!temp.array) {
                                temp.array = {};
                            }
                            if (!temp.array[field]) {
                                temp.array[field] = {};
                            }
                            // compruebo si se ha querido eliminar
                            // tslint:disable-next-line:quotemark
                            if (!value || value === "<p></p>\n") {
                                delete temp.array[field][lang];
                            }
                            else {
                                if (field === 'href') {
                                    if (!temp.array.hasOwnProperty(Fields.tags)) {
                                        temp.array[Fields.tags] = {};
                                    }
                                    if (!temp.array.tags.hasOwnProperty(lang)) {
                                        temp.array.tags[lang] = {};
                                    }
                                    temp.array.tags[lang][field] = value;
                                }
                                else {
                                    temp.array[field][lang] = value;
                                }
                            }
                            _this.setState({ dataweb: temp });
                            _this.handleChange('dataweb', temp, null);
                        }, onChangeOrder: function (images) {
                            // elimino images para así tomar el valor recibido
                            var tempDataWeb = {};
                            for (var key in _this.state.dataweb) {
                                if (!key.includes('image')) {
                                    tempDataWeb[key] = _this.state.dataweb[key];
                                }
                            }
                            var result = __assign(__assign({}, tempDataWeb), images);
                            _this.setState({ dataweb: result });
                            _this.handleChange('dataweb', result, null);
                        } })),
            React.createElement(ButtonsBar, null,
                hasParent && (React.createElement(StyledButton, { onClick: this.handleCancel }, t('back'))),
                this.props.values && canBeDisabled ? (disabled ? (React.createElement(StyledButton, { isDisabled: true, onClick: this.handleDisable(false) }, t('enable'))) : (React.createElement(StyledButton, { onClick: this.handleDisable(true) }, t('disable')))) : canBeDeleted ? (React.createElement(StyledButton, { onClick: this.handleDelete }, t('delete'))) : null,
                React.createElement(StyledButton, { onClick: this.handleReset }, t('reset')),
                React.createElement(StyledButton, { primary: true, loading: loading, onClick: this.handleSubmit }, t('save')))));
    };
    StretchesFormulario.prototype.parsedValues = function (props) {
        if (props === void 0) { props = this.props; }
        var values = props.values || {};
        // console.log('FormStretch - parsedValues - values: ', values)
        var result = this.fields.reduce(function (fields, field) {
            var _a;
            // console.log('FormStretch - field', field)
            // console.log('FormStretch - values[field.column? field.column: field.name]', values[field.column? field.column: field.name])
            return __assign(__assign({}, fields), (_a = {}, _a[field.column ? field.column : field.name] = values[field.column ? field.column : field.name] === undefined
                ? field.defaultValue
                : values[field.column ? field.column : field.name] ||
                    (field.type === FieldType.Select
                        ? field.placeholder
                            ? null
                            : field.options && field.options[0] && field.options[0].value
                        : field.type === FieldType.Date
                            ? new Date()
                            : values[field.column ? field.column : field.name]), _a));
        }, {});
        // console.log('parsedValues - result', result)
        // agrego type y dateEvent
        result['type'] = values['type'];
        result['dateEvent'] = values['dateEvent'];
        return result;
    };
    StretchesFormulario.prototype.parsedPricesValues = function () {
        var values = [];
        if (this.props.priceFields) {
            values = cloneDeep(this.props.priceFields);
        }
        var result = values.reduce(function (previous, field) {
            var _a;
            // console.log('parsedPricesValues - field', field)
            return __assign(__assign({}, previous), (_a = {}, _a[field.name] = field.value || field.value === 0
                ? field.value
                : field.type === FieldType.Select
                    ? field.placeholder
                        ? null
                        : field.options && field.options[0] && field.options[0].value
                    : field.type === FieldType.Date
                        ? new Date()
                        : values[field.name], _a));
        }, {});
        return result;
    };
    StretchesFormulario.prototype.parsedCollaboratorPricesValues = function (collaboratorSelected, vuelta) {
        var fields = !vuelta
            ? this.props.collaboratorPriceFields[collaboratorSelected.id] || []
            : this.props.collaboratorVueltaPriceFields[collaboratorSelected.id] || [];
        // console.log('parsedCollaboratorPricesValues - this.priceFields: ', fields)
        var result = fields.reduce(function (previous, field) {
            var _a;
            // console.log('parsedPricesValues - field', field)
            return __assign(__assign({}, previous), (_a = {}, _a[field.name] = field.value || field.value === 0
                ? field.value
                : field.type === FieldType.Select
                    ? field.placeholder
                        ? null
                        : field.options && field.options[0] && field.options[0].value
                    : field.type === FieldType.Date
                        ? new Date()
                        : fields[field.name], _a));
        }, {});
        // console.log('parsedCollaboratorPricesValues - result', result)
        return result;
    };
    StretchesFormulario.prototype.parsedAfiliatePricesValues = function (afiliateSelected, vuelta) {
        var fields = !vuelta
            ? this.props.afiliatePriceFields[afiliateSelected.id] || []
            : this.props.afiliateVueltaPriceFields[afiliateSelected.id] || [];
        // console.log('parsedAfiliatePricesValues - this.priceAfiliatePricesFields: ', fields)
        var result = fields.reduce(function (previous, field) {
            var _a;
            // console.log('parsedPricesValues - field', field)
            return __assign(__assign({}, previous), (_a = {}, _a[field.name] = field.value || field.value === 0
                ? field.value
                : field.type === FieldType.Select
                    ? field.placeholder
                        ? null
                        : field.options && field.options[0] && field.options[0].value
                    : field.type === FieldType.Date
                        ? new Date()
                        : fields[field.name], _a));
        }, {});
        // console.log('parsedAfiliatePricesValues - result', result)
        return result;
    };
    StretchesFormulario.prototype.parsedVueltaPricesValues = function (props) {
        if (props === void 0) { props = this.props; }
        var values = this.vueltaPriceFields || [];
        // console.log('parsedPricesValues - this.priceFields: ', values)
        var result = values.reduce(function (fields, field) {
            var _a;
            // console.log('parsedPricesValues - field', field)
            return __assign(__assign({}, fields), (_a = {}, _a[field.name] = field.value || field.value === 0
                ? field.value
                : field.type === FieldType.Select
                    ? field.placeholder
                        ? null
                        : field.options && field.options[0] && field.options[0].value
                    : field.type === FieldType.Date
                        ? new Date()
                        : values[field.name], _a));
        }, {});
        // console.log('parsedPricesValues - result', result)
        return result;
    };
    StretchesFormulario.prototype.parsedStretechOtasValues = function (props) {
        return props.values.stretchOtas;
    };
    StretchesFormulario = __decorate([
        Loading(function (props) { return [
            props.stores.taxes.read().then(function (taxes) { return ({ taxes: taxes }); }),
            props.stores.scheduleStore.read().then(function (schedules) { return ({ schedules: schedules }); }),
            props.stores.moneysStore.read().then(function (moneys) { return ({ moneys: moneys }); }),
            props.stores.destinationsStore.read().then(function (destinations) { return ({ destinations: destinations }); }),
            props.stores.categoriesStore.read().then(function (categories) { return ({ categories: categories }); }),
            props.stores.tagsStore.read().then(function (tags) { return ({ tags: tags }); }),
        ]; })
    ], StretchesFormulario);
    return StretchesFormulario;
}(Component));
export default StretchesFormulario;
var Wrapper = cxs('div')((_a = {
        paddingBottom: Theme.size.bar
    },
    _a[mediaQueries.desktop] = {
        display: 'flex',
        flexWrap: 'wrap',
        // paddingBottom: 0,
        marginBottom: Theme.size.bar,
        overflow: 'auto'
    },
    _a));
var borderStyle = {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.color.hairline,
    animation: ''
};
var ViewSelected;
(function (ViewSelected) {
    ViewSelected["Field"] = "field";
    ViewSelected["CalendarAvailable"] = "calendaAvailable";
    ViewSelected["Prices"] = "prices";
    ViewSelected["CalendarPrices"] = "calendarPrices";
    ViewSelected["Mapsite"] = "mapsite";
    ViewSelected["Seatmap"] = "seatMap";
    ViewSelected["Areaconfig"] = "areaconfig";
    ViewSelected["Ota"] = "ota";
    ViewSelected["ManifestHeader"] = "manifestHeader";
    ViewSelected["DataWeb"] = "dataWeb";
    ViewSelected["Marketing"] = "marketing";
})(ViewSelected || (ViewSelected = {}));
function shouldRenderField(field, values, showHora, showVehicles) {
    var name = field.name;
    if ((name === 'horasIda' || name === 'horasVuelta') && !showHora)
        return false;
    if (name === 'vehicles' && !showVehicles)
        return false;
    if (name === 'dateMaxToReserve' && values['typeMaxToReserve'] !== 'byDate')
        return false;
    if (name === 'valueMaxToReserve' && values['typeMaxToReserve'] === 'byDate')
        return false;
    if (name === 'dateMaxBeforeReserve' && values['typeMaxToReserve'] !== 'byDate')
        return false;
    if (name === 'valueMaxBeforeReserve' && values['typeMaxBeforeReserve'] === 'byDate')
        return false;
    return true;
}
var defaultViewSelected = ViewSelected.Field;
function getPattern() {
    var pattern = [
        2,
        2,
        4,
        3,
        1,
        1,
        3,
        3,
        3,
        3,
        3,
        2,
        3,
        1,
        1,
        1,
        1
    ];
    return pattern;
}
function groupFieldsByPattern(fields, pattern) {
    var rows = [];
    var index = 0;
    for (var _i = 0, pattern_1 = pattern; _i < pattern_1.length; _i++) {
        var count = pattern_1[_i];
        var row = fields.slice(index, index + count);
        if (row.length) {
            rows.push(row);
        }
        index += count;
    }
    return rows;
}
function markConditionalFields(fields, values, showHora, showVehicles) {
    return fields.map(function (field) {
        var disabled = false;
        if ((field.name === 'horasIda' || field.name === 'horasVuelta') &&
            !showHora) {
            disabled = true;
        }
        if (field.name === 'vehicles' && !showVehicles) {
            disabled = true;
        }
        if (field.name === 'dateMaxToReserve') {
            if (values['typeMaxToReserve'] !== 'byDate') {
                disabled = true;
            }
        }
        if (field.name === 'valueMaxToReserve') {
            if (values['typeMaxToReserve'] === 'byDate') {
                disabled = true;
            }
        }
        if (field.name === 'dateMaxBeforeReserve') {
            if (values['typeMaxToReserve'] !== 'byDate') {
                disabled = true;
            }
        }
        if (field.name === 'valueMaxBeforeReserve') {
            if (values['typeMaxBeforeReserve'] === 'byDate') {
                disabled = true;
            }
        }
        return __assign(__assign({}, field), { disabled: disabled });
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stretches/container/StretchesFormulario.tsx
// module id = 1276
// module chunks = 0